<template>
  <div>
    <div v-for="mainAddon in groupedAddons" :key="mainAddon.id">
      <!-- One sub-addon case -->
      <span
        v-if="mainAddon.subAddons.length === 1"
        class="product-variation"
        v-text="
          `${mainAddon.mainAddonName}: ${mainAddon.subAddons[0].addonName}`
        "
      />
      <!-- Multiple sub-addons case -->
      <span
        v-else-if="mainAddon.subAddons.length > 1"
        class="product-variation"
        v-text="mainAddon.mainAddonName"
      />
      <div v-if="mainAddon.subAddons.length > 1" class="mt-1 ml-4">
        <p
          v-for="addon in mainAddon.subAddons"
          :key="addon.id"
          class="product-addons-list"
          style="margin-bottom: 6px"
          v-text="
            addon.quantity +
            ' X ' +
            addon.addonName +
            ' (' +
            formatMoney(addon.addonTotalPrice) +
            ')'
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupedAddonsList",
  props: {
    groupedAddons: {
      type: Array,
      required: true,
    },
    formatMoney: {
      type: Function,
      required: true, // Pass your format function as prop for flexibility
    },
  },
};
</script>
